import FilterDailyReport from './FilterDailyReport';

export default FilterDailyReport